import Container from "../components/Container/Container";
import {Button, Form, Input, InputNumber, message, Modal, Space, Table, Tag, Select} from "antd";
import {useContext, useEffect, useState} from "react";
import getPartners from "../api/partner/getPartners";
import useAuthHeader from "../hooks/useAuthHeader";
import { formatDateTime, numberFormat} from "../helpers/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faGlobe, faPercent, faTeletype, faChartLine} from "@fortawesome/free-solid-svg-icons";
import Search from "../components/Search/Search";
import FormDrawer from "../components/FormDrawer/FormDrawer";
import createPartner from "../api/partner/createPartner";
import LoadingContext from "../contexts/LoadingContext";
import TextCopy from "../components/TextCopy";
import {EditOutlined, GoldOutlined, SecurityScanOutlined, DeleteOutlined} from "@ant-design/icons";
import getIpAddress from "../api/partner/getIpAddress";
import getFees from "../api/user/fee/getFees";
import EditTableCell from "../components/Table/EditTableCell/EditTableCell";
import updateFee from "../api/user/fee/updateFee";
import updateInfo from "../api/partner/updateInfo";
import updateBalance from "../api/partner/updateBalance";
import getInfoTelegram from "../api/partner/getInfoTelegram";
import updateInfoTelegram from "../api/partner/updateInfoTelegram";
import changeIpAddress from "../api/partner/changeIpAddress";
import changePassword from "../api/user/auth/changePassword";
import getTelegramList from "../api/telegram/getTelegramList";
import createTelegram from "../api/telegram/createTelegram";
import deleteTelegram from "../api/telegram/deleteTelegram";
import { useNavigate } from "react-router-dom";

function Partner() {
    const [data,setData] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const accessToken = useAuthHeader();
    const [form] = Form.useForm();
    const [formAdd] = Form.useForm();
    const [formFee] = Form.useForm();
    const [formIpAddress] = Form.useForm();
    const [open,setOpen] = useState(false);
    const [openFormPassword,setOpenFormPassword] = useState(false);
    const [openModelIpAddress, setOpenIpAddress] = useState(false);
    const [tableLoadingIpAddress,setTableLoadingIpAddress] = useState(false);
    const [record,setRecord] = useState({});
    const [loadingBtnIpAddress,setLoadingBtnIpAddress] = useState(false);
    const [openModalFee,setOpenModalFee] = useState(false);
    const [tableLoadingFee,setTableLoadingFee] = useState(false);
    const [dataSourceFee,setDataSourceFee] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const {loading,setLoading} = useContext(LoadingContext);
    const [editingKey, setEditingKey] = useState('');
    const [editingPartner, setEditingPartner] = useState('');
    const [formPartner] = Form.useForm();
    const [formBalance] = Form.useForm();
    const [formTelegram] = Form.useForm();
    const [formCreateTelegram] = Form.useForm();
    const [openModalTelegram, setOpenModalTelegram] = useState(false);
    const [telegramList, setTelegramList] = useState([]);
    const [tableLoadingTelegram, setTableLoadingTelegram] = useState(false);
    const [formPassword] = Form.useForm();
    const [summaryData, setSummaryData] = useState({
        totalBalance: 0
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [balance, setBalance] = useState(0); // Số dư ban đầu
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const navigate = useNavigate();
    const isEditing = (_record) => _record.userFeeId === editingKey;

    const isEditingPartner = (_record) => _record.userId === editingPartner;

    const cancel = () => {
        setEditingKey('');
    };

    const cancelPartner = () => {
        setEditingPartner('');
    }

    const permissionOptions = [
        { value: 'view_pay_in', label: 'Xem IN' },
        { value: 'view_pay_out', label: 'Xem OUT' },
        { value: 'view_transactions', label: 'Xem giao dịch' },
        { value: 'view_hooks', label: 'Xem hook' },
        { value: 'view_withdrawals', label: 'Xem rút tiền' },
        { value: 'view_statistics', label: 'Xem thống kê' },
        { value: 'view_deposits', label: 'Xem nạp tiền' },
        { value: 'view_balance', label: 'Xem số dư' },
    ];

    const items = [
        {
            name: 'name',
            placeholder: 'Tên đối tác',
            type: 'text'
        },
        {
            name: 'username',
            placeholder: 'Tên tài khoản',
            type: 'text'
        }
    ]

    const itemAdds = [
        {
            name: 'name',
            placeholder: 'Nhập tên',
            type: 'text',
            label: 'Tên',
            required: true
        },
        {
            name: 'username',
            placeholder: 'Nhập tên tài khoản',
            type: 'text',
            label: 'Tên tài khoản',
            required: true
        },
        {
            name: 'email',
            placeholder: 'Nhập Email',
            type: 'text',
            label: 'Email',
            required: false
        },
        {
            name: 'password',
            placeholder: 'Nhập mật khẩu',
            type: 'password',
            label: 'Mật khẩu',
            required: true
        },
        {
            name: 'rePassword',
            placeholder: 'Nhập lại mật khẩu',
            type: 'password',
            label: 'Xác nhận mật khẩu',
            required: true
        },
    ]

    const columns = [
        {
            title: 'ID',
            dataIndex: 'userId',
            sorter: true,
            align: 'center'
        },
        {
            title: 'Tên',
            dataIndex: 'name',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return (value) ? <Tag>{value}</Tag> : <Tag>Trống</Tag>
            }
        },
        {
            title: 'Số dư',
            dataIndex: 'balance',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'API Key',
            dataIndex: 'apiKey',
            width: '340px',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Mã bảo mật',
            dataIndex: 'signKey',
            width: '340px',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Tối đa nickname',
            dataIndex: 'maxNickname',
            align: 'center',
            editable: true,
            inputType: 'number',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Xác thực 2 lớp',
            dataIndex: 'is2faEnabled',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Xác thực IP',
            dataIndex: 'isBlockIp',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Xác thực tiền chuyển',
            dataIndex: 'isEqualAmount',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Dùng ngân hàng riêng',
            dataIndex: 'useBankPrivate',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Callback pay in lỗi',
            dataIndex: 'isHookFailedPayIn',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Xác thực Telegram',
            dataIndex: 'isTelegramVerified',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Nhập khoản',
            dataIndex: 'payInState',
            align: 'center',
            editable: true,
            inputType: 'select',
            filters: [
                {
                    text: 'Hoạt động',
                    value: 'active'
                },
                {
                    text: 'Ngừng',
                    value: 'disabled'
                }
            ],
            render: (value) => {
                if (value === 'active') {
                    return <Tag color={'green'}>Hoạt động</Tag>
                }
                return <Tag color={'red'}>Ngừng</Tag>
            }
        },
        {
            title: 'Xuất khoản',
            dataIndex: 'payOutState',
            align: 'center',
            editable: true,
            inputType: 'select',
            filters: [
                {
                    text: 'Hoạt động',
                    value: 'active'
                },
                {
                    text: 'Ngừng',
                    value: 'disabled'
                }
            ],
            render: (value) => {
                if (value === 'active') {
                    return <Tag color={'green'}>Hoạt động</Tag>
                }
                return <Tag color={'red'}>Ngừng</Tag>
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'isBanned',
            align: 'center',
            editable: true,
            inputType: 'select',
            filters: [
                {
                    text: 'Hoạt động',
                    value: false
                },
                {
                    text: 'Bị chặn',
                    value: true
                }
            ],
            render: (value) => {
                if (value === false) {
                    return <Tag color={'green'}>Hoạt động</Tag>
                }
                return <Tag color={'red'}>Bị chặn</Tag>
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            render: (value) => {
                return formatDateTime(value);
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,_record) => {
                const editable = isEditingPartner(_record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => savePartner(_record.userId)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancelPartner}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <Space>
                        <Button icon={<EditOutlined/>} disabled={editingKey !== ''} onClick={() => editPartner(_record)} title={'Chỉnh sửa'}/>
                        <Button icon={<SecurityScanOutlined/>} onClick={() => handleOpenChangePassword(_record)} title={'Chỉnh sửa mật khẩu'}/>
                        <Button onClick={() => handleIpAddress(_record)} icon={<FontAwesomeIcon icon={faGlobe}/>} title={'Địa chỉ IP'}/>
                        <Button onClick={() => handleFee(_record)} icon={<FontAwesomeIcon icon={faPercent}/>} title={'Chiết khấu'}/>
                        <Button onClick={() => handleOpenModalBalance(_record)} icon={<GoldOutlined/>} title={'Chỉnh số dư'}/>
                        <Button onClick={() => handleOpenModalTelegram(_record)} icon={<FontAwesomeIcon icon={faTeletype} />} title={'Thêm telegram'}/>
                        <Button onClick={() => handleViewStatistics(_record)} icon={<FontAwesomeIcon icon={faChartLine} />} title={'Xem thống kê'} type={'primary'} ghost/>
                    </Space>
                )
            }
        }
    ];

    const handleOpenModalTelegram = async (_record) => {
        setRecord(_record);
        setOpenModalTelegram(true);
        // Reset form và set giá trị mặc định
        formCreateTelegram.resetFields();
        formCreateTelegram.setFieldsValue({
            type: 'payin',
            from_amount: 0,
            to_amount: 999999999
        });
        await fetchTelegramList(_record.userId);
    }

    const fetchTelegramList = async (userId) => {
        setTableLoadingTelegram(true);
        const response = await getTelegramList(accessToken, userId);
        if (response.success) {
            setTelegramList(response.data);
        } else {
            message.error(response.message);
        }
        setTableLoadingTelegram(false);
    }

    const handleCreateTelegram = async (values) => {
        console.log('Telegram form values:', values); // Debug log
        setTableLoadingTelegram(true);
        const telegramData = {
            user_id: record.userId,
            ...values
        };
        const response = await createTelegram(accessToken, telegramData);
        console.log('Create telegram response:', response); // Debug log
        if (response.success) {
            message.success('Tạo cấu hình telegram thành công');
            formCreateTelegram.resetFields();
            formCreateTelegram.setFieldsValue({
                type: 'payin',
                from_amount: 0,
                to_amount: 999999999
            });
            await fetchTelegramList(record.userId);
        } else {
            message.error(response.message || 'Có lỗi xảy ra khi tạo telegram');
        }
        setTableLoadingTelegram(false);
    }

    const handleDeleteTelegram = async (uuid, name) => {
        Modal.confirm({
            title: 'Xác nhận xóa',
            content: `Bạn có chắc chắn muốn xóa cấu hình telegram "${name}"?`,
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                setTableLoadingTelegram(true);
                const response = await deleteTelegram(accessToken, uuid);
                if (response.success) {
                    message.success('Xóa cấu hình telegram thành công');
                    await fetchTelegramList(record.userId);
                } else {
                    message.error(response.message);
                }
                setTableLoadingTelegram(false);
            }
        });
    }

    const handleUpdateInfoTelegram = async (values) => {
        const response = await updateInfoTelegram(accessToken, record.userId, values);
        if (response.success) {
            message.success('Thêm thông tin telegram thành công.')
        } else {
            message.error(response.message);
        }
    }

    const handleViewStatistics = (_record) => {
        navigate(`/admin/partner-statistic/${_record.userId}`);
    }

    const handleFee = async (_record) => {
        setOpenModalFee(true);
        await fetchFees(_record.userId);
        setRecord(_record);
    }

    const handleIpAddress = async (_record) => {
        setOpenIpAddress(true);
        await fetchIpAddress(_record.userId);
        setRecord(_record);
    }

    const handleOpenChangePassword = async (_record) => {
        setOpenFormPassword(true);
        setRecord(_record);
    }

    const fetchIpAddress = async (userId) => {
        setTableLoadingIpAddress(true);
        const response = await getIpAddress(accessToken,userId);
        if (response.success) {
            formIpAddress.setFieldValue('ipAllowList', response.data.ipAllowList)
        }
        setTableLoadingIpAddress(false);
    }

    const fetchFees = async (userId) => {
        setTableLoadingFee(true);
        const response = await getFees(accessToken,userId);
        if (response.success) {
            setDataSourceFee(response.data);
        }
        setTableLoadingFee(false);
    }

    const fetchDataPartners = async () => {
        setTableLoading(true);
        try {
            const response = await getPartners(accessToken,tableParams);
            if (response.success) {
                setData(response.data.data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: response.data.total
                    },
                });
                setSummaryData({
                    totalBalance: response.data.totalBalance
                })
            }
        }
        catch (e) {}
        setTableLoading(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            sorter,
        });
    };

    const handleSearch =  () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }

    const handleSubmitAdd = (values) => {
        console.log('Form values:', values); // Debug log
        const fetchData = async () => {
            setLoading(true);
            const response = await createPartner(accessToken, values);
            console.log('API response:', response); // Debug log
            if (response.success) {
                fetchDataPartners();
                setOpen(false);
                formAdd.resetFields();
                message.success('Tạo đối tác thành công');
            } else {
                message.error(response.message || 'Có lỗi xảy ra khi tạo đối tác');
            }
            setLoading(false);
        }
        fetchData();
    }

    const handleAddIpAddress = (values) => {
        console.log('IP form values:', values); // Debug log
        setLoadingBtnIpAddress(true);
        const fetchAddIpAddress = async () => {
            const response = await changeIpAddress(accessToken, {
                userId: record.userId,
                ipAllowList: values.ipAllowList
            });
            if (response.success) {
                messageApi.success('Cập nhật danh sách địa chỉ IP cho phép thành công.');
                setOpenIpAddress(false);
                formIpAddress.resetFields();
            }
            else {
                messageApi.error(response.message || 'Có lỗi xảy ra khi cập nhật IP');
            }
        }

        fetchAddIpAddress().finally(() => setLoadingBtnIpAddress(false));
    }

    const edit = (_record) => {
        formFee.setFieldsValue({
            payInFee: 0,
            payOutFee: 0,
            ..._record,
        });
        setEditingKey(_record.userFeeId);
    };

    const editPartner = (_record) => {
        formPartner.setFieldsValue({
            email: '',
            bankInFee: 0,
            bankOutFee: 0,
            ..._record
        })
        setEditingPartner(_record.userId);
    }

    const save =  async (userFeeId) => {
        setTableLoadingFee(true);
        try {
            const row = await formFee.validateFields();
            const params = {
                userFeeId,
                ...row
            };
            const response = await updateFee(accessToken, params);
            if (response.success) {
                const newData = [...dataSourceFee];
                const index = newData.findIndex((item) => userFeeId === item.userFeeId);
                if (index > -1) {
                    const item = newData[index];
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                    setDataSourceFee(newData);
                    setEditingKey('');
                } else {
                    newData.push(row);
                    setDataSourceFee(newData);
                    setEditingKey('');
                }
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
            setTableLoadingFee(false);
        }
    }

    const savePartner = async (userId)=> {
        setTableLoading(true);
        try {
            const row = await formPartner.validateFields();
            const params = {
                userId,
                ...row
            };
            const response = await updateInfo(accessToken, params);
            if (response.success) {
                updatePartner(userId, row);
                message.success('Cập nhật thông tin đối tác thành công');
            }
            else {
                message.error(response.message);
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
            setTableLoading(false);
        }
    }

    const updatePartner = (userId, row) => {
        const newData = [...data];
        const index = newData.findIndex((item) => userId === item.userId);
        if (index > -1) {
            const item = newData[index];
            newData.splice(index, 1, {
                ...item,
                ...row,
            });
            setData(newData);
            setEditingPartner('');
        } else {
            newData.push(row);
            setData(newData);
            setEditingPartner('');
        }
    }

    const columnFees = [
        {
            title: 'ID',
            dataIndex: 'userFeeId',
            align: 'center',
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Phí pay in (%)',
            dataIndex: 'payInFee',
            align: 'center',
            editable: true,
        },
        {
            title: 'Phí pay out (%)',
            dataIndex: 'payOutFee',
            align: 'center',
            editable: true,
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,_record) => {
                const editable = isEditing(_record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => save(_record.userFeeId)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancel}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <Button icon={<EditOutlined/>} disabled={editingKey !== ''} onClick={() => edit(_record)} type={'primary'}>Chỉnh sửa</Button>
                );
            }
        }
    ];

    const mergedColumnFees = columnFees.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (_record) => ({
                _record,
                inputType: 'number',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(_record),
            }),
        };
    });

    const mergedColumnPartners = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (_record) => ({
                _record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditingPartner(_record),
                filters: col.filters ?? []
            }),
        };
    });

    const telegramColumns = [
        {
            title: 'Tên',
            dataIndex: 'name',
            align: 'center',
            render: (value) => <Tag>{value}</Tag>
        },
        {
            title: 'Chat ID',
            dataIndex: 'chatId',
            align: 'center',
            render: (value) => <Tag>{value}</Tag>
        },
        {
            title: 'API Token',
            dataIndex: 'apiToken',
            align: 'center',
            width: '300px',
            render: (value) => <TextCopy value={value} />
        },
        {
            title: 'Loại',
            dataIndex: 'type',
            align: 'center',
            render: (value) => {
                const typeLabels = {
                    'payin': 'Nạp tiền',
                    'payout': 'Rút tiền',
                    'approve': 'Xác nhận rút tiền',
                    'alert_nickname': 'Thông báo nickname',
                    'default': 'Mặc định'
                };
                const typeColors = {
                    'payin': 'green',
                    'payout': 'orange', 
                    'approve': 'red',
                    'alert_nickname': 'yellow',
                    'default': 'blue'
                };
                return <Tag color={typeColors[value] || 'blue'}>{typeLabels[value] || value}</Tag>
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'center',
            render: (value) => (
                <Tag color={value === 'active' ? 'green' : 'red'}>
                    {value === 'active' ? 'Hoạt động' : 'Ngừng'}
                </Tag>
            )
        },
        {
            title: 'Kích hoạt',
            dataIndex: 'isActive',
            align: 'center',
            render: (value) => (
                <Tag color={value ? 'green' : 'red'}>
                    {value ? 'Có' : 'Không'}
                </Tag>
            )
        },
        {
            title: 'Giới hạn',
            dataIndex: 'limit',
            align: 'center',
            render: (value, record) => {
                if (!record || typeof record !== 'object' || record.type === 'alert_nickname') return <Tag>Không giới hạn</Tag>;
                return (
                    <Space>
                        <Tag>{numberFormat(record.fromAmount ?? 0)}</Tag>
                        <Tag>{numberFormat(record.toAmount ?? 0)}</Tag>
                    </Space>    
                );
            }
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            align: 'center',
            render: (value) => formatDateTime(value)
        },
        {
            title: 'Hành động',
            align: 'center',
            width: '120px',
            render: (_, record) => (
                <Button 
                    icon={<DeleteOutlined />} 
                    danger 
                    size="small"
                    onClick={() => handleDeleteTelegram(record.uuid, record.name)}
                    title="Xóa cấu hình telegram"
                >
                    Xóa
                </Button>
            )
        }
    ];

    const handleOpenModalBalance = (_record) => {
        setRecord(_record);
        setBalance(_record.balance)
        setIsModalVisible(true);
    }

    const handleSubmitBalance = async (io) => {
        setLoading(true);
        const data = formBalance.getFieldsValue();
        const response = await updateBalance(accessToken, {
            io,
            userId: record.userId,
            ...data
        });
        if (response.success) {
            updatePartner(record.userId, response.data);
            message.success('Cập nhật số dư thành công')
        }
        else {
            message.error(response.message);
        }
        setLoading(false);
    };

    const handleChangePassword = async (values) => {
        console.log('Password form values:', values); // Debug log
        setLoading(true);
        const response = await changePassword(accessToken, record.userId, values.password, values.rePassword);
        console.log('Change password response:', response); // Debug log
        if (response.success) {
            messageApi.success('Cập nhật mật khẩu cho đối tác thành công.');
            setOpenFormPassword(false);
            formPassword.resetFields();
        }
        else {
            messageApi.error(response.message || 'Có lỗi xảy ra khi cập nhật mật khẩu');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchDataPartners();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        JSON.stringify(tableParams.sorter),
        JSON.stringify(tableParams.search),
        JSON.stringify(tableParams.filters),
    ]);

    return (
        <Container>
            {contextHolder}
            <Space
                style={{
                    marginBottom: 16,
                }}
            >
                <Button type={'primary'} ghost={true} onClick={() => setOpen(true)} icon={<FontAwesomeIcon icon={faAdd}/>}>Thêm đối tác</Button>
            </Space>
            <Search
                form={form}
                onSearch={handleSearch}
                items={items}
            />
            <Modal
                title={`Quản lý Telegram - ${record.name || record.username || ''}`}
                open={openModalTelegram}
                onCancel={() => setOpenModalTelegram(false)}
                width={1400}
                footer={null}
            >
                <div style={{ marginBottom: 16 }}>
                    <h3>Tạo cấu hình Telegram mới</h3>
                    <Form
                        form={formCreateTelegram}
                        layout={'vertical'}
                        onFinish={handleCreateTelegram}
                        style={{ border: '1px solid #d9d9d9', padding: 16, borderRadius: 8, marginBottom: 16 }}
                        initialValues={{
                            type: 'payin',
                            from_amount: 0,
                            to_amount: 999999999
                        }}
                    >
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                            <Form.Item
                                name={'chat_id'}
                                label={'Chat ID'}
                                required={true}
                                style={{ flex: '1 1 200px' }}
                            >
                                <Input placeholder="123456789" />
                            </Form.Item>
                            <Form.Item
                                name={'api_token'}
                                label={'API Token'}
                                required={true}
                                style={{ flex: '1 1 400px' }}
                            >
                                <Input placeholder="123456789:ABC-DEF1234567890" />
                            </Form.Item>
                            <Form.Item
                                name={'type'}
                                label={'Loại'}
                                style={{ flex: '1 1 200px' }}
                            >
                                <Select 
                                    placeholder="Chọn loại telegram"
                                    options={[
                                        { value: 'payin', label: 'Nạp tiền' },
                                        { value: 'payout', label: 'Rút tiền' },
                                        { value: 'approve', label: 'Xác nhận rút tiền' },
                                        { value: 'alert_nickname', label: 'Thông báo nickname' }
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                            <Form.Item
                                name={'from_amount'}
                                label={'Từ số tiền'}
                                style={{ flex: '1 1 200px' }}
                            >
                                <InputNumber
                                    min={0}
                                    style={{ width: '100%' }}
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    placeholder="0"
                                />
                            </Form.Item>
                            <Form.Item
                                name={'to_amount'}
                                label={'Đến số tiền'}
                                style={{ flex: '1 1 200px' }}
                            >
                                <InputNumber
                                    min={0}
                                    style={{ width: '100%' }}
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    placeholder="999,999,999"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item>
                            <Button 
                                type={'primary'} 
                                htmlType={'submit'}
                                loading={tableLoadingTelegram}
                                icon={<FontAwesomeIcon icon={faAdd} />}
                            >
                                Tạo cấu hình
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                
                <div>
                    <h3>Danh sách cấu hình Telegram</h3>
                    <Table
                        rowKey={'uuid'}
                        columns={telegramColumns}
                        dataSource={telegramList}
                        bordered={true}
                        scroll={{ x: 1320 }}
                        loading={tableLoadingTelegram}
                        pagination={{ pageSize: 5 }}
                    />
                </div>
            </Modal>
            <Modal
                title="Quản lý số dư"
                open={isModalVisible}
                onOk={() => setIsModalVisible(false)}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <Space style={{ marginBottom: "16px" }}>
                    <p>Số dư hiện tại: </p>
                    <Tag>{numberFormat(balance)} VND</Tag>
                </Space>
                <Form
                    style={{ marginBottom: "16px" }}
                    layout={'vertical'}
                    form={formBalance}
                >
                    <Form.Item
                        name={'amount'}
                        label={'Số tiền:'}
                    >
                        <InputNumber
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            min={0}
                            style={{
                                width: '100%'
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name={'description'}
                        label={'Ghi chú'}
                    >
                        <Input/>
                    </Form.Item>
                </Form>
                <Space
                    size={'middle'}
                >
                    <Button type={'primary'} onClick={() => handleSubmitBalance(1)}>Cộng</Button>
                    <Button type={'dashed'} danger={true} onClick={() => handleSubmitBalance(-1)}>Trừ</Button>
                </Space>
            </Modal>
            <Form
                form={formPartner}
                component={false}
            >
                <Table
                    rowKey={'userId'}
                    columns={mergedColumnPartners}
                    dataSource={data}
                    bordered={true}
                    scroll={{
                        x: 2400,
                    }}
                    loading={tableLoading}
                    pagination={tableParams.pagination}
                    onChange={handleTableChange}
                    components={{
                        body: {
                            cell: EditTableCell
                        }
                    }}
                    rowClassName={'editable-row'}
                    summary={(data) => {

                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={4}>
                                    Thống kê
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1} align={'center'}>
                                    <Tag color={'blue'}>{numberFormat(summaryData.totalBalance)}</Tag>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }}
                />
            </Form>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                items={itemAdds}
                onSubmit={handleSubmitAdd}
                title={'Thêm mới đối tác'}
                form={formAdd}
            />
            <FormDrawer
                open={openFormPassword}
                onClose={() => setOpenFormPassword(false)}
                items={[{
                    name: 'password',
                    placeholder: 'Nhập mật khẩu',
                    type: 'password',
                    label: 'Mật khẩu',
                    required: true
                },
                {
                    name: 'rePassword',
                    placeholder: 'Nhập lại mật khẩu',
                    type: 'password',
                    label: 'Xác nhận mật khẩu',
                    required: true
                }]}
                onSubmit={handleChangePassword}
                title={'Chỉnh sửa mật khẩu'}
                form={formPassword}
            />
            <Modal
                title={'Quản lý địa chỉ IP cho phép'}
                open={openModelIpAddress}
                onCancel={() => setOpenIpAddress(false)}
                width={800}
                footer={null}
                loading={tableLoadingIpAddress}
            >
                <Form
                    form={formIpAddress}
                    layout="vertical"
                    onFinish={handleAddIpAddress}
                >
                    <Form.Item
                        name={'ipAllowList'}
                        label="Danh sách IP"
                    >
                        <Input.TextArea
                            rows={6}
                            placeholder="Danh sách IP đã được thêm"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button loading={loadingBtnIpAddress} type="primary" htmlType="submit">
                            Xác nhận
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title={'Danh sách thông tin chiết khấu'}
                open={openModalFee}
                onCancel={() => setOpenModalFee(false)}
                width={1000}
                footer={null}
            >
                <Form
                    form={formFee}
                    component={false}
                >
                    <Table
                        rowKey={'userFeeId'}
                        columns={mergedColumnFees}
                        bordered={true}
                        scroll={{
                            x: 800,
                        }}
                        loading={tableLoadingFee}
                        dataSource={dataSourceFee}
                        components={{
                            body: {
                                cell: EditTableCell
                            }
                        }}
                    />
                </Form>
            </Modal>
        </Container>
    )
}

export default Partner;
